import HorizontalScroll from '@cartwhl/ui/atoms/HorizontalScroll';
import Text from '@cartwhl/ui/base/Text';

import { useCarousel } from '../../../hooks/useCarousel';
import { VerticalNavButtons } from './VerticalNavButtons';

const testimonials = [
  {
    quote:
      'Real helpful in getting our price point per episode down, which allows me just to do more and be more ambitious with my animated series.',
    author: 'Mark Andrews, Academy Award-winning Director',
    company: 'Dogstar',
  },
  {
    quote:
      'So many different workflows and frontier tools are built from the tool’s perspective rather than the end-user. Everything that I’ve interacted with in Cartwheel feels like it’s meant to sit within an animator’s needs and wants - it feels like it was actually designed by someone who actually animates.',
    author: 'Ryan Summers, Creative Innovation Lead',
    company: 'Sarofsky',
  },
  {
    quote:
      'I’ve been testing QuickMagic and MoveAI… but when I tried yours I was like, ‘Oh, this is a lot better.’ It’s just the smoothest by far.',
    author: 'Product Specialist',
    company: 'AAA Game Studio',
  },
  {
    quote:
      'I tried others: Flow Studio ‘cheats the motion’—turn and it jitters/skips—and Move AI is super cool but super expensive, pushing you toward building a mocap studio. Cartwheel just works.',
    author: 'Animation Director',
    company: 'Mid-Size Studio',
  },
  {
    quote:
      'I gave it a try. And to be honest, it’s another level for me. The interface is really friendly. I was able to test out a few of my videos from before and I can get way better results than QuickMagic, and it tops MoveAI as well, so I told my lead, ‘Dude, I think we got our answer. We can rely on Cartwheel.',
    author: 'Animator',
    company: 'web3 gaming startup',
  },
];

export default function TestimonialsSection() {
  const {
    scrollRef,
    firstItemRef,
    intersectionRef,
    canScrollPrev,
    canScrollNext,
    visibleIndex,
    scrollPrev,
    scrollNext,
  } = useCarousel({
    itemCount: testimonials.length,
    snapToItem: true,
    trackVisibleIndex: true,
  });

  return (
    <section ref={intersectionRef} className="pb-[80px]">
      {/* Carousel - extends beyond container */}
      <HorizontalScroll ref={scrollRef} as="div">
        {testimonials.map((testimonial, index) => (
          <div
            key={`${testimonial.author}-${testimonial.company}`}
            ref={index === 0 ? firstItemRef : undefined}
            className="flex w-full shrink-0 snap-start"
          >
            <div
              className={`flex w-[874px] flex-col gap-10 transition-opacity duration-500 ease-in-out lg:gap-16 ${
                index === (visibleIndex ?? 0) ? 'opacity-100' : 'opacity-0'
              }`}
            >
              <div className="flex max-w-[380px] lg:max-w-[768px]">
                <Text
                  variant="web/body/medium/lg"
                  lg:variant="web/body/medium/xl"
                  className="xs:-ml-4 xs:w-3 mr-1 -ml-3 w-2"
                >
                  “
                </Text>
                <Text
                  as="p"
                  variant="web/body/medium/lg"
                  lg:variant="web/body/medium/xl"
                >
                  {testimonial.quote}”
                </Text>
              </div>
              <Text
                as="div"
                variant="web/body/medium/md"
                lg:variant="web/body/medium/24"
                className="text-gray-45"
              >
                {testimonial.author}, {testimonial.company}
              </Text>
            </div>
          </div>
        ))}
      </HorizontalScroll>

      {/* Navigation */}
      <VerticalNavButtons
        disablePrev={!canScrollPrev}
        disableNext={!canScrollNext}
        onPrev={scrollPrev}
        onNext={scrollNext}
        className="container mt-10"
      />
    </section>
  );
}
